import LoadingBackdropWrapper from '@/components/Modal/common/LoadingBackdropWrapper';
import ModalBody from '@/components/Modal/common/ModalBody';
import { Button, Modal } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { resetUserPassword } from '../data/userService';

const PasswordResetConfirmation = ({ open, userId, handleClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const onConfirmReset = async () => {
    setLoading(true);
    try {
      await resetUserPassword(userId);
      setLoading(false);

      handleClose();
      toast.success('User password reset successfully');
      onConfirm();
    } catch (_error) {
      handleClose();
      setLoading(false);
      toast.error('Something went wrong');
    }
  };

  return (
    <LoadingBackdropWrapper backdropOpen={loading}>
      <Modal open={open} onClose={handleClose} aria-labelledby='modal-title'>
        <ModalBody>
          <p className='mb-2 font-semibold'>Are you sure you want to reset this user&apos;s password?</p>
          <div className='flex justify-end gap-[9px]'>
            <Button variant='contained' onClick={onConfirmReset}>
              Confirm
            </Button>
            <Button variant='outlined' color='error' onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </LoadingBackdropWrapper>
  );
};

PasswordResetConfirmation.propTypes = {
  open: PropTypes.bool,
  userId: PropTypes.number,
  handleClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PasswordResetConfirmation;
